
import { PostObject } from '../store/post/api/interface';
import { CompanyFeed } from '../store/social/api/interface';

export const getterSocialPost = (posts: CompanyFeed[] = [], totalPosts: number = 6) => {
    if (posts?.length === 0) return [];
    if (posts?.length <= totalPosts) return posts;
    return posts.slice(0, totalPosts);
};
